// extracted by mini-css-extract-plugin
export default {"pendingEnachBox":"pendingEnach_pendingEnachBox__nM5BB","pendingEnachBox1":"pendingEnach_pendingEnachBox1__R+XOK"};